import { useEffect, useState } from "react";
import {
  GetStateStorage,
  IsValidLoginAuth,
  IsValidSemiAuth,
  SetStateInStorage,
} from "common/storage";
import { isUserAgent } from "common/roles/role";

export const BROKERAGE_OFFICE_DIALOG_DELAY_MS = 1500;

export const getBrokerageOfficeDialogContext = () => {
  const stateData = GetStateStorage() || {};
  const agentData = stateData.userData || {};
  const listgenUserID = agentData.listgenUserID;
  const userRole = stateData.userRole || agentData.listgenRoleID;

  return {
    agentData,
    listgenUserID,
    accountName: agentData.listgenUserFirstName || "Agent",
    isValidLogin: IsValidLoginAuth(),
    isValidSemiLogin: IsValidSemiAuth(),
    isAgentSession: isUserAgent(userRole),
  };
};

export const shouldShowOfficeConfirmationModal = (agentData = {}) =>
  agentData.showOfficeConfirmationModal === true;

export const dismissOfficeConfirmationModal = () => {
  const stateData = GetStateStorage() || {};
  if (stateData.userData) {
    SetStateInStorage({
      ...stateData,
      userData: {
        ...stateData.userData,
        showOfficeConfirmationModal: false,
      },
    });
  }
};

export const isBrokerageOfficeDialogEligible = (context) =>
  // /home is reachable during registration semi-auth (Routes.jsx requireSemiAuth).
  !context.isValidSemiLogin &&
  context.isValidLogin &&
  context.isAgentSession &&
  shouldShowOfficeConfirmationModal(context.agentData);

export const useBrokerageOfficeDialog = () => {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState(getBrokerageOfficeDialogContext);

  useEffect(() => {
    // Registration users can navigate to /home before full login; never show modal then.
    if (IsValidSemiAuth()) {
      return undefined;
    }

    const timer = setTimeout(() => {
      const nextContext = getBrokerageOfficeDialogContext();
      setContext(nextContext);
      if (isBrokerageOfficeDialogEligible(nextContext)) {
        setOpen(true);
      }
    }, BROKERAGE_OFFICE_DIALOG_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => setOpen(false);

  return {
    open,
    onClose: handleClose,
    accountName: context.accountName,
    listgenUserID: context.listgenUserID,
  };
};
